import {
	getHostDomain
} from '../index.js'

// 辅助函数：判断是否使用 website 路径
function isWebsitePath() {
	const subdomain = window.location.hostname.split('.')[0];
	const segments = subdomain.split('-');
	
	// wx-{gameCode}-{channel} 或 {gameCode}-website 格式都使用 website 路径
	return segments[1] === 'website';
}

export function getGoodsJsonUrl(game) {
	let hostDomain = getHostDomain();
	if (isWebsitePath()) {
		return hostDomain + '/json/website/goods/' + game + '.json?v' + (new Date()).getTime();
	} else {
		return hostDomain + '/static/json/goods/' + game + '.json?v' + (new Date()).getTime();
	}
}

export function getWelfareJsonUrl(game) {
	let hostDomain = getHostDomain();
	if (isWebsitePath()) {
		return hostDomain + '/json/website/welfare/' + game + '.json?v' + (new Date()).getTime();
	} else {
		return hostDomain + '/static/json/welfare/' + game + '.json?v' + (new Date()).getTime();
	}
}

export function getRebateJsonUrl(game) {
	let hostDomain = getHostDomain();
	if (isWebsitePath()) {
		return hostDomain + '/json/website/rebate/' + game + '.json?v' + (new Date()).getTime();
	} else {
		return hostDomain + '/static/json/rebate/' + game + '.json?v' + (new Date()).getTime();
	}
}

export function getPointsJsonUrl(game) {
	let hostDomain = getHostDomain();
	if (isWebsitePath()) {
		return hostDomain + '/json/website/points/' + game + '.json?v' + (new Date()).getTime();
	} else {
		return hostDomain + '/static/json/points/' + game + '.json?v' + (new Date()).getTime();
	}
}

export function getGameJsonUrl(game) {
	let hostDomain = getHostDomain();
	if (isWebsitePath()) {
		return hostDomain + '/json/website/game/' + game + '.json?v' + (new Date()).getTime();
	} else {
		return hostDomain + '/static/json/game/' + game + '.json?v' + (new Date()).getTime();
	}
}